import {Alert, Button, Popconfirm} from "antd";

type DraftResumeBannerProps = {
  onStartFresh: () => void;
};

const alertStyle: React.CSSProperties = {
  background: "#E1F6F5",
  border: "1px solid #50D3CD",
  borderRadius: "5px",
};

const messageStyle: React.CSSProperties = {
  color: "#002421",
  fontSize: "1.4rem",
};

const buttonStyle: React.CSSProperties = {
  padding: 0,
  height: "auto",
  fontWeight: 600,
  textDecoration: "underline",
  color: "#002421",
};

export function DraftResumeBanner({onStartFresh}: DraftResumeBannerProps) {
  return (
    <Alert
      message={
        <div style={messageStyle}>
          You're continuing where you left off — we saved your progress as a draft.
        </div>
      }
      style={alertStyle}
      action={
        <Popconfirm
          title="This will discard your saved draft."
          okText="Start over"
          cancelText="Cancel"
          onConfirm={onStartFresh}
        >
          <Button type="text" style={buttonStyle}>
            Start over
          </Button>
        </Popconfirm>
      }
    />
  );
}
